import { Host, h, } from "@stencil/core";
import state from "../store";
export class GxgOptions {
    constructor() {
        this.maxWidth = "100%";
        this.width = "100%";
        this.zIndex = "10";
        this.position = "left";
        this.iconDirection = "vertical";
        this.maxVisibleOptions = 6;
        this.optionsVisible = false;
    }
    optionsButton;
    optionsItemsContainer;
    el;
    clickedOutsideContainer = this.clickedOutsideContainerFunc.bind(this);
    componentWillLoad() {
        this.assignDataIds();
        if (state.large) {
            this.el.style.setProperty("--optionHeight", "24px");
        }
        else {
            this.el.style.setProperty("--optionHeight", "20px");
        }
    }
    componentDidLoad() {
        this.optionsItemsContainer.style.setProperty("max-height", `calc(var(--optionHeight) * ${this.maxVisibleOptions})`);
    }
    clickedOutsideContainerFunc(event) {
        const x = event.x;
        const y = event.y;
        //Contextual menu coordinates
        const optionsContainerArea = this.optionsItemsContainer.getBoundingClientRect();
        if ((x > optionsContainerArea.left &&
            x < optionsContainerArea.right &&
            y > optionsContainerArea.top &&
            y < optionsContainerArea.bottom) ||
            (event.screenX === 0 &&
                event.screenY === 0 &&
                event.clientX === 0 &&
                event.clientY === 0)) {
            //Click happened inside the combo
        }
        else {
            this.optionsVisible = false;
            //Click happened outside the combo
        }
    }
    disconnectedCallback() {
        document.removeEventListener("click", this.clickedOutsideContainer, true);
    }
    showItemsHandler(optionsVisible) {
        if (optionsVisible) {
            document.addEventListener("click", this.clickedOutsideContainer, true);
        }
        else {
            document.removeEventListener("click", this.clickedOutsideContainer, true);
        }
    }
    assignDataIds() {
        //this is for internal use
        const options = this.el.querySelectorAll("*");
        options.forEach((option, i) => {
            option.setAttribute("data-id", i.toString());
        });
    }
    toggleOptions(e) {
        e.stopPropagation();
        this.optionsVisible = !this.optionsVisible;
    }
    prevOption(dataId) {
        const currentItem = this.el.querySelector("gxg-options-item[data-id='" + dataId + "']");
        const prevOption = currentItem.previousElementSibling;
        if (prevOption) {
            prevOption.focus();
        }
        else {
            this.optionsVisible = false;
            this.optionsButton.focus();
        }
    }
    nextOption(dataId) {
        const currentItem = this.el.querySelector("gxg-options-item[data-id='" + dataId + "']");
        const nextOption = currentItem.nextElementSibling;
        if (nextOption) {
            nextOption.focus();
        }
    }
    keyDownHandler(event) {
        const escape = event.detail["escape"];
        const direction = event.detail["direction"];
        const dataId = event.detail["dataId"];
        if (escape) {
            this.optionsVisible = false;
            this.optionsButton.focus();
        }
        else if (direction === "ArrowUp") {
            this.prevOption(dataId);
        }
        else if (direction === "ArrowDown") {
            this.nextOption(dataId);
        }
    }
    optionSelectedHandler() {
        //An option was selected. Close options.
        this.optionsVisible = false;
    }
    optionsButtonKeyDownHandler(e) {
        const code = e.code;
        if (code === "Escape") {
            this.optionsVisible = false;
        }
        if (code === "ArrowDown") {
            if (this.optionsVisible) {
                const firstOption = this.el.querySelector("gxg-options-item");
                if (firstOption) {
                    firstOption.focus();
                }
            }
            else {
                this.optionsVisible = true;
            }
        }
    }
    icon() {
        return this.iconDirection === "horizontal"
            ? "gemini-tools/show-more-horizontal"
            : "gemini-tools/show-more-vertical";
    }
    render() {
        return (h(Host, { class: {
                options: true,
                "options--visible": this.optionsVisible,
                "options--left": this.position === "left",
                "options--right": this.position === "right",
                large: state.large,
            } }, h("div", { class: "options__container" }, h("gxg-button", { icon: this.icon(), type: "tertiary", onClick: this.toggleOptions.bind(this), onKeyDown: this.optionsButtonKeyDownHandler.bind(this), ref: (el) => (this.optionsButton = el) }), h("div", { class: "options__items-container", style: {
                width: this.width,
                maxWidth: this.maxWidth,
                zIndex: this.zIndex,
            }, ref: (el) => (this.optionsItemsContainer = el) }, h("slot", null)))));
    }
    static get is() { return "gxg-options"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["gxg-options.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["gxg-options.css"]
        };
    }
    static get properties() {
        return {
            "maxWidth": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "max-width",
                "reflect": false,
                "defaultValue": "\"100%\""
            },
            "width": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "width",
                "reflect": false,
                "defaultValue": "\"100%\""
            },
            "zIndex": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "z-index",
                "reflect": false,
                "defaultValue": "\"10\""
            },
            "position": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "\"left\" | \"right\"",
                    "resolved": "\"left\" | \"right\"",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "position",
                "reflect": false,
                "defaultValue": "\"left\""
            },
            "iconDirection": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "\"vertical\" | \"horizontal\"",
                    "resolved": "\"horizontal\" | \"vertical\"",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "icon-direction",
                "reflect": false,
                "defaultValue": "\"vertical\""
            },
            "maxVisibleOptions": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "max-visible-options",
                "reflect": false,
                "defaultValue": "6"
            }
        };
    }
    static get states() {
        return {
            "optionsVisible": {}
        };
    }
    static get elementRef() { return "el"; }
    static get watchers() {
        return [{
                "propName": "optionsVisible",
                "methodName": "showItemsHandler"
            }];
    }
    static get listeners() {
        return [{
                "name": "keyDown",
                "method": "keyDownHandler",
                "target": undefined,
                "capture": false,
                "passive": false
            }, {
                "name": "optionSelected",
                "method": "optionSelectedHandler",
                "target": undefined,
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=gxg-options.js.map
